export function validateSimulationUserPassword(value) {
  if (value === '' || value === null || value === undefined) {
    return '密码不能为空'
  }

  const password = String(value)

  if (password.length < 8 || password.length > 22) {
    return '密码长度需为8-22位'
  }

  if (/\s/.test(password)) {
    return '密码必须同时包含数字、大写字母、小写字母和特殊字符，且不能包含空格'
  }

  const complexityRule = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/
  if (!complexityRule.test(password)) {
    return '密码必须同时包含数字、大写字母、小写字母和特殊字符，且不能包含空格'
  }

  return ''
}

export const simulationUserPasswordRule = {
  validator(rule, value, callback) {
    const message = validateSimulationUserPassword(value)
    if (message) {
      callback(new Error(message))
      return
    }
    callback()
  },
  trigger: 'blur',
}
